<template>
  <FlotoAnchorLink :aria-label="$t('delete')" @click="triggerAction">
    <MIcon name="trash-alt" class="action-menu-icon" />
    <span class="ml-1 action-menu-text">
      {{ $t('delete') }}
    </span>
    <FlotoConfirmModal
      :open="showModal"
      prevent-auto-close-on-confirm
      :processing="processing"
      @hide="showModal = false"
      @confirm="handleConfirmAction"
    >
      <template v-slot:icon>
        <MIcon name="trash-alt" class="w-full text-secondary-red" size="2x" />
      </template>
      <template v-slot:message>
        {{
          $t('confirm_delete', {
            resource: $tc(moduleName),
          })
        }}
      </template>
    </FlotoConfirmModal>
  </FlotoAnchorLink>
</template>

<script>
export default {
  name: 'MarkAsSpam',
  props: {
    moduleName: { type: String, required: true },
    handleDeleteItems: { type: Function, default: undefined },
  },
  data() {
    return {
      showModal: false,
      processing: false,
    }
  },
  methods: {
    handleConfirmAction() {
      this.$emit('done')
      if (this.handleDeleteItems) {
        this.processing = true
        this.handleDeleteItems()
          .then(() => {
            this.showModal = false
          })
          .finally(() => (this.processing = false))
      } else {
        this.showModal = false
      }
    },
    triggerAction() {
      this.$emit('trigger')
      // show modal after dropdown is hide
      setTimeout(() => {
        this.showModal = true
      }, 400)
    },
  },
}
</script>
